
import { Snackbar, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import { useNavigate } from "react-router-dom";
import withLoader from "../../../components/layouts/WithLoader";
import BankService from "../../../services/PosService/BankService";
import UtilsFormule from "../../../utils/UtilsFormule";
import Select from "react-select";
import makeAnimated from "react-select/animated";
const styles = {
    container: (base) => ({
        ...base,
        flex: 1,
    }),
};
const ChargerWalletVirement = ({ startLoading, stopLoading }) => {
    const navigate = useNavigate();
    const animatedComponents = makeAnimated();

    const [datePayement, setDatePayement] = useState("");
    const [codeVirement, setCodeVirement] = useState("");
    const [fileName, setFileName] = useState("");
    const [openInfoAlert, setOpenInfoAlert] = useState(false);
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [successAlertText, setSuccessAlertText] = useState();
    const [infoAlertText, setInfoAlertText] = useState();
    const [file, setFile] = useState([]);
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [amount, setAmount] = useState();
    const [selectedOption, setSelectedOption] = useState(null);
    const [payementSelectPlaceHolder, setPayemenSelectPlaceHolder] =
        useState("Choisir...");

        
    const [searchPay, setSearchPay] = useState("");
    const [listSearchPay, setListSearchPay] = useState([]);
    const [isSearchPay, setIsSearchPay] = useState(false);
    const [disableInputs, setDisableInputs] = useState(false);
    const changeDatePayement = (event) => {
        setDatePayement(event.target.value.concat(":59"));
    };
    const changeAmount = (event) => {
        setAmount(event.target.value);
    };
    const handleSuccessClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSuccessAlert(false);
    };

    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    const changeCodePayementVirement = (event) => {
        setCodeVirement(event.target.value);
    };

    const onUploadFileHandler = (e) => {
        if (e.target.files[0].size > 2097152) {
            setOpenInfoAlert(true);
            setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
        } else {
            setFileName(e.target.files[0].name);

            setFile(e.target.files[0]);
        }
    };

    const payerBill = (e) => {
        const url = window.location.pathname.split("/")[1];
        if (url === "chargerWallet") {

        if (codeVirement === "") {
            console.log("codeVirement", codeVirement);
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : le code de virement est vide ");
        } else if (datePayement === "") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : la date est vide ");
        } else if (amount === "") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : Le montant est vide ");
        } else {
            let walletModel = {
                idUser: getCurrentUserId(),
                idBa: parseInt(localStorage.getItem("banqueAccount")),
                idWallet: parseInt(sessionStorage.getItem("idWallet")),
                typePayement: 3,
                echanceDate: datePayement,
                ammountPayed: amount,
                urlFile: "any",
                numVirement: codeVirement,
            };
            startLoading();
            if (file.length !== 0) {
                const uploadData = new FormData();
                uploadData.append("picture", file);

                UploadAndDownloadService.uploadFile(
                    "/sales/uploadFileSelling/uploadFile/Payement",
                    uploadData
                )
                    .then((response) => {
                        if (response.data["success"]) {
                            walletModel.urlFile = response.data.success;
                            TierAccountService.addWalletPayement(walletModel)
                                .then((response) => {
                                    console.log(response);
                                    if (response.data["error"]) {
                                        setOpenErrorAlert(true);
                                        setErrorAlertText("Erreur :  " + response.data["error"]);                                    } else {
                                        setOpenSuccessAlert(true);
                                        setSuccessAlertText("Enregistrement avec succées");
                                        setTimeout(() => {
                                            navigate(`/walletClient`);
                                        }, 2000);
                                    }
                                })
                                .catch((error) => {
                                    // console.log("error", error);
                                    setOpenErrorAlert(true);
                                    setErrorAlertText("Erreur :  " + error);
                                })

                        } else {
                        }
                    })
                    .catch((error) => {
                        setOpenErrorAlert(true);
                        setErrorAlertText("Erreur :  " + error);
                    })
                    .finally(() => {
                        stopLoading();
                    });
            } else {
                startLoading();
                TierAccountService.addWalletPayement(walletModel)
                    .then((response) => {
                        console.log(response);
                        if (response.data["error"]) {
                        } else {
                            setOpenSuccessAlert(true);
                            setSuccessAlertText("Enregistrement avec succées");
                            setTimeout(() => {
                                navigate(`/walletClient`);
                            }, 2000);
                        }
                    })
                    .catch((error) => {
                        // console.log("error", error);
                        setOpenErrorAlert(true);
                        setErrorAlertText("Erreur :  " + error);
                    })
                    .finally(() => {
                        stopLoading();
                    });
            }
        }
    }else if (url === "chargerWalletFournisseur") {
        if (codeVirement === "") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : le code de virement est vide ");
        } else if (datePayement === "") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : la date est vide ");
        } else if (amount === "") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : Le montant est vide ");
        } else {
            let walletModel = {
                idUser: getCurrentUserId(),
                idBa: parseInt(localStorage.getItem("banqueAccount")),
                idWallet: parseInt(sessionStorage.getItem("idWallet")),
                typePayement: 3,
                echanceDate: datePayement,
                ammountPayed: amount,
                urlFile: "any",
                numVirement: codeVirement,
            };
            startLoading();
            if (file.length !== 0) {
                const uploadData = new FormData();
                uploadData.append("picture", file);

                UploadAndDownloadService.uploadFile(
                    "/retail/uploadFile/uploadFile/Payement",
                    uploadData
                )
                    .then((response) => {
                        if (response.data["success"]) {
                            walletModel.urlFile = response.data.success;
                            TierAccountService.addWalletPayementFournisseur(walletModel)
                                .then((response) => {
                                    console.log(response);
                                    if (response.data["error"]) {
                                        setOpenErrorAlert(true);
                                        setErrorAlertText("Erreur :  " + response.data["error"]);                                    } else {
                                        setOpenSuccessAlert(true);
                                        setSuccessAlertText("Enregistrement avec succées");
                                        setTimeout(() => {
                                            navigate(`/walletFournisseur`);
                                        }, 2000);
                                    }
                                })
                                .catch((error) => {
                                    setOpenErrorAlert(true);
                                    setErrorAlertText("Erreur :  " + error);
                                })

                        } else {
                        }
                    })
                    .catch((error) => {
                        setOpenErrorAlert(true);
                        setErrorAlertText("Erreur :  " + error);
                    })
                    .finally(() => {
                        stopLoading();
                    });
            } else {
                startLoading();
                TierAccountService.addWalletPayementFournisseur(walletModel)
                    .then((response) => {
                        console.log(response);
                        if (response.data["error"]) {
                        } else {
                            setOpenSuccessAlert(true);
                            setSuccessAlertText("Enregistrement avec succées");
                            setTimeout(() => {
                                navigate(`/walletFournisseur`);
                            }, 2000);
                        }
                    })
                    .catch((error) => {
                        setOpenErrorAlert(true);
                        setErrorAlertText("Erreur :  " + error);
                    })
                    .finally(() => {
                        stopLoading();
                    });
            }
        }

    }
    };
    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };
    const changeSearchPay = (event) => {
        setSearchPay(event.target.value);
    };
    const searchPayement = () => {
        startLoading();
        BankService.searchPayementByRef(getCurrentUserId(), 3, searchPay).then((response) => {

            let backendData = [{}];

            response.data.success.map((element) => {
                let elem = {
                    value: element["codeCheque"], label: element["codeCheque"] + "-" + element["emetteur"], customElements: {
                        amount: element["amountPayed"],
                        dateEcheance:UtilsFormule.formatDateInput( element["echeanceDate"]),
                        emetteur: element["emetteur"]
                    }
                };
                backendData.push(elem);
            })
            setListSearchPay(backendData)
            setIsSearchPay(true)
            console.log(response)
        }).catch((e) => {
            console.log(e)

        }).finally(() => {
            stopLoading();
        })

    }
    const onChangeSelectedCheque = (selectedOptionn) => {
        setSelectedOption();
        setPayemenSelectPlaceHolder(selectedOptionn.label);
        setAmount(selectedOptionn.customElements.amount);
        setDatePayement(selectedOptionn.customElements.dateEcheance);
        setCodeVirement(selectedOptionn.value);
        setDisableInputs(true);

    };
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <label>Charger le wallet par virement: </label>
                </div>
            </div>
            <div className="input-group">
                <div
                    className="input-group-prepend"
                    style={{ width: "95%" }}
                >
                    <input
                        value={searchPay}
                        onChange={changeSearchPay}
                        class="form-control"
                        placeholder="chercher payement"
                        type="text"
                    />
                </div>
                <div className=" input-group-append">
                    <button
                        onClick={searchPayement}
                        type="button"
                        class="btn btn-dark"
                    >
                        <i class="fas  fa-solid fa-arrow-down"></i>
                    </button>
                </div>
            </div>
            <br />
            {isSearchPay && <Select
                styles={styles}
                closeMenuOnSelect={true}
                components={animatedComponents}
                defaultValue={selectedOption}
                onChange={onChangeSelectedCheque}
                options={listSearchPay}
                placeholder={payementSelectPlaceHolder}
            />}

            <div class="row">
                <div class="col-md-4">
                    <label>Montant : </label>
                    <input
                        type="number"
                        min="0"
                        step="0.1"
                        class="form-control"
                        placeholder="Montant "
                        name="amount"
                        value={amount}
                        onChange={changeAmount}
                        disabled={disableInputs}

                    />
                </div>
                <div class="col-md-4">
                    <label>Référence virement: </label>
                    <input
                        value={codeVirement}
                        onChange={changeCodePayementVirement}
                        class="form-control"
                        placeholder="Ref.valeur"
                        type="number"
                        disabled={disableInputs}

                    />
                </div>

                <div class="col-md-4">
                    <label>Date de l'échéance </label>
                    <br />
                    <TextField
                        style={{ width: "100%" }}
                        className="col-sm-12"
                        variant="outlined"
                        value={datePayement}
                        onChange={changeDatePayement}
                        id="datetime-local"
                        type="datetime-local"
                        defaultValue="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        size="small"
                        disabled={disableInputs}

                    />
                </div>
                <div class="col-md-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div class="form-group">
                                <label for="exampleInputFile">Ajouter Virement </label>
                                <div class="input-group">
                                    <div class="custom-file">
                                        <input
                                            accept="application/pdf, .jpg, .jpeg, .png"
                                            type="file"
                                            className="custom-file-input"
                                            id="exampleInputFile"
                                            onChange={onUploadFileHandler}
                                        />
                                        <label class="custom-file-label" for="exampleInputFile">
                                            {fileName}{" "}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <label>Compte bancaire </label>
                    <ListBanquesToPayement type={1} />
                </div>
                <div class="col-12">
                    <button
                        type="submit"
                        onClick={payerBill}
                        className="btn btn-dark float-right"
                    >
                        Payer
                    </button>
                </div>
            </div>
            <Snackbar
                open={openSuccessAlert}
                autoHideDuration={2000}
                onClose={handleSuccessClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleSuccessClose} severity="success">
                    {successAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openInfoAlert}
                autoHideDuration={4000}
                onClose={handleInfoClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert onClose={handleInfoClose} severity="info">
                    {infoAlertText}
                </Alert>
            </Snackbar>
        </>
    );
}
export default withLoader(ChargerWalletVirement)